import _has from './_has';

var toString = Object.prototype.toString;
var _isArguments = function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
};

export default _isArguments;


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_isArguments.js
// module id = 1071
// module chunks = 1